{
  "version": 1,
  "asset_id": "0790e7dc-194a-48d2-9ad1-f198f30cdc78",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0790e7dc-194a-48d2-9ad1-f198f30cdc78/hiatal-normal-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0790e7dc-194a-48d2-9ad1-f198f30cdc78/hiatal-normal-1200.webp",
  "original_filename": "hiatal-normal-1200.webp",
  "size": 61164,
  "content_type": "image/webp",
  "created_at": "2026-09-23T01:03:13Z"
}
